import Vue from 'vue'
import Router from 'vue-router'
import { $error, $loading } from 'src/utils'
import { TOKEN_KEY, WHITE_LIST } from 'src/constants'
import { handleLogin, initAgentConfig } from 'src/utils/work-chat'

import routes from './routers'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  // 移动端使用以项目名命名的子目录
  base: '/',
  routes,
  scrollBehavior (to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    return savedPosition || { x: 0, y: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  try {
    if (to?.meta?.title) {
      document.title = to.meta.title
    }
    if (WHITE_LIST.includes(to.name)) {
      next()
    } else {
      const token = localStorage.getItem(TOKEN_KEY)
      if (!token) {
        handleLogin()
      } else {
        if (process.env.NODE_ENV === 'production') {
          const Loading = $loading()
          if (to?.meta.inside) {
            await initAgentConfig()
          } else {
            // 外部用户怎么办？
          }
          Loading.clear()
        }
      }
      next()
    }
  } catch (e) {
    $error(e)
  }
})

router.onError(err => {
  $error('页面加载出错', true)
  throw err
})

export default router
